import { baseColors, baseFontFamily, baseFontSize } from "@Constants/baseStyles"
import React from "react"
import { View, Text, TouchableOpacity } from "react-native"
import { RFValue } from "react-native-responsive-fontsize"

export function CustomTabBar({ state, descriptors, navigation }) {
    const focusedOptions = descriptors[state.routes[state.index].key].options

    if (focusedOptions.tabBarVisible === false) {
        return null
    }

    return (
        <View
            style={{
                flexDirection: "row",
                backgroundColor: baseColors.white,
                borderTopWidth: 0.2,
                borderColor: "rgba(0,0,0,0.1)",
                elevation: 2,
                height: 75,
                paddingTop: 10,
                paddingBottom: 0
            }}
        >
            {state.routes.map((route, index) => {
                const { options } = descriptors[route.key]

                const label =
                    options.tabBarLabel !== undefined
                        ? options.tabBarLabel
                        : options.title !== undefined
                        ? options.title
                        : route.name

                const isFocused = state.index === index

                const onPress = () => {
                    const event = navigation.emit({
                        type: "tabPress",
                        target: route.key,
                        canPreventDefault: true
                    })

                    if (!isFocused && !event.defaultPrevented) {
                        navigation.navigate(route.name)
                    }
                }

                const onLongPress = () => {
                    navigation.emit({
                        type: "tabLongPress",
                        target: route.key
                    })
                }

                return (
                    <TouchableOpacity
                        key={index}
                        accessibilityRole="button"
                        accessibilityState={isFocused ? { selected: true } : {}}
                        accessibilityLabel={options.tabBarAccessibilityLabel}
                        testID={options.tabBarTestID}
                        onPress={onPress}
                        onLongPress={onLongPress}
                        style={{
                            flex: 1,
                            justifyContent: "center",
                            alignContent: "center",
                            alignItems: "center",
                            paddingBottom: 10
                        }}
                    >
                        <options.tabBarIcon
                            color={isFocused ? options.tabBarActiveTintColor : options.tabBarInactiveTintColor}
                        />

                        <Text
                            style={{
                                marginTop: RFValue(5),
                                fontSize: baseFontSize.sm,
                                fontFamily: baseFontFamily.OpenSansSemiBold,
                                color: isFocused ? options.tabBarActiveTintColor : options.tabBarInactiveTintColor
                            }}
                        >
                            {label}
                        </Text>
                    </TouchableOpacity>
                )
            })}
        </View>
    )
}
